import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center bold text-lg mb-2 mt-2 font-weight-bold" }, " Did You Get Our Mail? ", -1)
const _hoisted_2 = { class: "text-center text-lightGray font-weight-bold text-lg mb-2 mt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  class: "justify-center mb-10 mt-6",
  style: {"display":"flex"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-lightGray" }, "Didn't receive the code?")
], -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = {
  key: 0,
  class: "text-lightGray"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  class: "justify-center mt-12",
  style: {"display":"flex"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "text-lightGray text-center" }, [
  /*#__PURE__*/_createTextVNode(" By verifying my email, I agree to the Binkey's "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-tertiary",
    href: "https://www.joinbinkey.com/terms-and-conditions"
  }, " Terms of Service"),
  /*#__PURE__*/_createTextVNode(" and confirm that I have read Binkey's "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-tertiary",
    href: "https://www.joinbinkey.com/privacy-policy"
  }, " Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" and accept the Store Terms. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BinkeyLogo = _resolveComponent("BinkeyLogo")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BinkeyLogo),
    _createVNode(_component_v_sheet, {
      class: "mx-auto my-auto",
      width: _ctx.sheetWidth,
      color: "#f0f0f0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "my-14 pa-8 card-container" }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("h3", _hoisted_2, [
              _createTextVNode(" Enter the six digit code we sent to your email "),
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.email), 1)
            ]),
            _createVNode(_component_v_row, {
              justify: "center",
              class: "mt-6"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  sm: "8",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_form, {
                      modelValue: _ctx.validOTP,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.validOTP) = $event)),
                      onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
                      class: "form-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_v_otp_input, {
                            value: _ctx.securityCode,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.securityCode) = $event)),
                            "data-testid": "otp-input",
                            ref: "otpInput",
                            "input-classes": "otp-input",
                            separator: " ",
                            "num-inputs": 6,
                            "should-auto-focus": true,
                            "is-input-num": true,
                            class: _normalizeClass({ 'invalid-otp': !_ctx.validOTP })
                          }, null, 8, ["value", "class"])
                        ]),
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_btn, {
                            disabled: !_ctx.canResend,
                            color: "tertiary",
                            class: "text-none",
                            variant: "text",
                            onClick: _ctx.reSendCode,
                            style: {"font-color":"primary","font-size":"18px","font-weight":"100","text-decoration":"underline"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Resend Code ")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          (_ctx.secondsRemaining > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.secondsRemaining) + " seconds left to resend ", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_v_btn, {
                            disabled: !_ctx.canContinue,
                            loading: _ctx.loading,
                            color: "primary",
                            type: "submit",
                            class: "rounded-lg text-capitalize",
                            width: "280",
                            height: "45",
                            variant: "elevated",
                            style: {"font-weight":"100","font-size":"16px"}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Next "),
                              _createVNode(_component_v_icon, {
                                size: "large",
                                class: "ml-2 w-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-arrow-right")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["disabled", "loading"])
                        ]),
                        _hoisted_10
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onSubmit"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              variant: "flat",
              class: "terms-container d-flex pa-4 mx-auto",
              width: _ctx.sheetWidth
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            }, 8, ["width"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["width"])
  ], 64))
}